import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const { user, logout, isAuthorized } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  if (!user) {
    return null; // Don't show navbar if user is not logged in
  }

  return (
    <nav className="bg-gray-800 shadow-lg border-b-2 border-gray-600">
      <div className="flex justify-between items-center max-w-6xl mx-auto h-16 px-6">
        {isAuthorized && (
          <div className="flex space-x-2">
            <NavLink 
              to="/" 
              end 
              className={({ isActive }) => 
                `enhanced-navbar-link ${isActive ? 'enhanced-navbar-link-active' : ''}`
              }
            >
              Home
            </NavLink>
            <NavLink 
              to="/team-members" 
              className={({ isActive }) => 
                `enhanced-navbar-link ${isActive ? 'enhanced-navbar-link-active' : ''}`
              }
            >
              Team Members
            </NavLink>
            <NavLink 
              to="/create-rota" 
              className={({ isActive }) => 
                `enhanced-navbar-link ${isActive ? 'enhanced-navbar-link-active' : ''}`
              }
            >
              Create Rota
            </NavLink>
            <NavLink 
              to="/schedules" 
              className={({ isActive }) => 
                `enhanced-navbar-link ${isActive ? 'enhanced-navbar-link-active' : ''}`
              }
            >
              Schedules
            </NavLink>
          </div>
        )}
        <div className="flex items-center space-x-4">
          <span className="text-gray-300 text-sm font-medium">{user.email}</span>
          <button 
            onClick={handleLogout} 
            className="enhanced-logout-btn"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;